import { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { map } from 'lodash'
import pluralize from 'pluralize'

import { InfoAlert } from 'components/alerts'
import Image from 'components/image'
import Link from 'components/link'

import { contactUsPath } from 'lib/urls'

import { FORM_KEY_NEW } from 'shared/constants'

import { getInsertCardOrders, getRegistryId } from 'registry/reducers'
import InsertCardOrderForm from './insert-card-order-form'

class InsertCardOrders extends Component {
  static propTypes = {
    insertCardOrders: PropTypes.array,
    registryId: PropTypes.number.isRequired,
  }

  state = {
    showAlreadyOrderedMessage:
      false ||
      (this.props.insertCardOrders && this.props.insertCardOrders.length),
  }

  render() {
    const { insertCardOrders } = this.props
    const alreadyOrdered = insertCardOrders && insertCardOrders.length

    return (
      <div>
        {this.state.showAlreadyOrderedMessage && alreadyOrdered ? (
          <InfoAlert>
            <p>
              Your order is being processed. Review or edit your existing{' '}
              {pluralize('order', insertCardOrders.length)} below.{' '}
              <Link url={contactUsPath} newWindow>
                Contact us
              </Link>{' '}
              if you have questions or want to order more.
            </p>
          </InfoAlert>
        ) : (
          <Image
            alt="Insert cards photo - front and back"
            className="img-responsive mbm"
            src="//images.babylist.com/image/upload/q_auto,f_auto,w_600/v1711061230/insert_cards_web_kkxm3a.jpg"
          />
        )}
        {alreadyOrdered ? (
          <div>
            {map(insertCardOrders, (insertCardOrder, idx) => (
              <div key={insertCardOrder.id}>
                <InsertCardOrderForm
                  insertCardOrder={insertCardOrder}
                  key={insertCardOrder.id}
                  formKey={insertCardOrder.id.toString()}
                />
                {idx + 1 < insertCardOrders.length ? (
                  <hr className="mbl" />
                ) : null}
              </div>
            ))}
          </div>
        ) : (
          <InsertCardOrderForm formKey={FORM_KEY_NEW} />
        )}
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    insertCardOrders: getInsertCardOrders(state),
    registryId: getRegistryId(state),
  }
}

export default connect(mapStateToProps)(InsertCardOrders)
